import React from 'react';
import classNames from 'classnames';
import { IS_DEVELOPMENT_BUILD } from '@jwp/ott-common/src/utils/common';
import { Link } from 'react-router-dom';

import MarkdownComponent from '../MarkdownComponent/MarkdownComponent';
import facebookUrl from '../../../../theme/assets/icons/facebook.svg';
import instagramUrl from '../../../../theme/assets/icons/instagram.svg';
import xUrl from '../../../../theme/assets/icons/x.svg';
import tiktokUrl from '../../../../theme/assets/icons/tiktok.svg';
import youtubeUrl from '../../../../theme/assets/icons/youtube.svg';
import letterboxdUrl from '../../../../theme/assets/icons/letterboxd.svg';
import mailUrl from '../../../../theme/assets/icons/mail.svg';

import styles from './Footer.module.scss';

type Props = {
  text: string;
};

const SOCIAL = [
  { name: 'Facebook', icon: facebookUrl, url: 'https://www.facebook.com/umbra.stream' },
  { name: 'Instagram', icon: instagramUrl, url: 'https://www.instagram.com/umbra.stream/' },
  { name: 'X', icon: xUrl, url: 'https://x.com/umbra_stream' },
  { name: 'TikTok', icon: tiktokUrl, url: 'https://www.tiktok.com/@umbra.stream?is_from_webapp=1&' },
  { name: 'YouTube', icon: youtubeUrl, url: 'https://youtube.com/@umbrastreamof?si=siu3cwRWBeqRD4se' },
  { name: 'Letterboxd', icon: letterboxdUrl, url: 'https://letterboxd.com/umbra_stream/' },
];

  const Footer: React.FC<Props> = ({ text }) => {
  const chunks = text.split('|').map((chuck) => chuck.trim());
  const footerContent = chunks.map((value, index) => <MarkdownComponent key={index} markdownString={value} inline tag={chunks.length > 1 ? 'li' : 'div'} />);
  const wrapper = chunks.length > 1 ? <ul className={styles.list}>{footerContent}</ul> : footerContent;

  return (
    <footer
      className={classNames(styles.footer, {
        [styles.testFixMargin]: IS_DEVELOPMENT_BUILD,
      })}
    >
      {wrapper}

      <div className={styles.links}>
        <Link to="/terminos" style={{ color: '#fff' }}>
          Términos y Condiciones
        </Link>

        <Link to="/avisos" style={{ color: '#fff', marginLeft: '15px' }}>
          Aviso de Privacidad
        </Link>
      </div>

      <div className={styles.social}>
        {/*Contacto*/}
        <a href="mailto:contacto@morbido.tv" className={styles.socialItem}>
          <img src={mailUrl} alt="Email" className={styles.emailIcon} style={{ width: '43px', height: '43px', verticalAlign: 'middle' }} />
        </a>

        {/* Redes sociales */}
        {SOCIAL.map((item) => (
          <a key={item.name} href={item.url} target="_blank" rel="noopener noreferrer" className={styles.socialItem}>
            <img
              src={item.icon}
              alt={item.name}
              className={item.name === 'Letterboxd' ? styles.noFilter : ''}
              style={{
                verticalAlign: 'middle',
                ...(item.name === 'YouTube'
                  ? { width: '50px', height: '50px' }
                  : item.name === 'Letterboxd'
                  ? { width: '40px', height: '40px' }
                  : { width: '30px', height: '30px' }),
              }}
            />
          </a>
        ))}
      </div>
    </footer>
  );
};

export default Footer;
